import { DispatchItem } from "./DispatchItem";

export class Round {
	roundId: number = 0;
	truckerId: number = 0;
	truckerName: string = '';
	notes: string = '';
	internalComments: string = '';
	dispatches: DispatchItem[] = [];
}